<template>
    <div>

        <div class="outer-player-container" :class="{ playerIsExpanded : playerIsExpanded, isTPG : isTPG, playerIsNotHidden : !playerIsHidden }">
            <div class="player-container" :class="{ playerIsExpanded : playerIsExpanded }">

                <div class="togglePlayer" :class="{ playerIsExpanded : playerIsExpanded }" @click="togglePlayer">
                    <font-awesome-icon icon="chevron-up"  aria-hidden="true" />
                </div>

                <div class="controlsContainer" :class="{ playerIsExpanded : playerIsExpanded }">
                    <div class="playButtonContainer" :class="{ playerIsExpanded : playerIsExpanded }">
                        <div id="playButton" @click="playButtonClicked" :class="{ playerIsExpanded : playerIsExpanded, isTPG : isTPG }">
                            {{playButtonText}}
                        </div>
                    </div>
                    <div class="skipIcon"
                        :class="{ playerIsExpanded : playerIsExpanded, isTPG:isTPG }"
                         @click="skipTrack()"
                         v-if="isInteractive == true">
                         <font-awesome-icon icon="step-forward" :class="{isTPG:isTPG}"  aria-hidden="false" />
                    </div>

                </div>
                <div class="progressContainer" :class="{ playerIsExpanded : playerIsExpanded }">
                    <div id="progressContainer"  :class="{ playerIsExpanded : playerIsExpanded }">
                        <div class="progressBarBottom"></div>
                        <div id="trackProgress"></div>
                    </div>

                    <div id="progressText" :class="{ playerIsExpanded : playerIsExpanded }">00:00</div>
                </div>

                <div class="volumeContainer">
                    <div class="volumeIcon">
                        <font-awesome-icon icon="volume-up"  aria-hidden="false" />
                    </div>
                    <div id="volumeContainer">
                        <div id="volumeBack"></div>
                        <div id="volumeFront"></div>
                        <table class="volumeControlTable">
                            <tr>
                                <td class="vCell" id="vc_m"
                                    @click="setVolume(0)"
                                    style="width:6px;border:0px;"></td>
                                <td v-for="n in 7"
                                    class="vCell"
                                    @click="setVolume(n)"
                                    :key="n"></td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="trackDetailContainer" :class="{ playerIsExpanded : playerIsExpanded }">
                        <div class="trackImageContainer" :class="{ playerIsExpanded : playerIsExpanded }">
                           <img v-if="currentTrack" :src="currentTrack.cover" onerror="javascript:this.src='/images/unknown-album.jpg'">
                        </div>
                        <div class="trackDetail" :class="{ playerIsExpanded : playerIsExpanded }">
                            <div class="playlistDescription" :class="{ playerIsExpanded : playerIsExpanded }" @click="redirectToPlaylistOrigin">
                                    {{ playlistOrigin }}
                            </div>
                            <div v-html="artistTitleString"
                                 class="trackArtist"
                                 :class="{ playerIsExpanded : playerIsExpanded }">
                            </div>
                        </div>
                </div>

                <div class="voteIconContainer" :class="{ playerIsExpanded : playerIsExpanded }"
                    v-if="allowVoting == '1'">
                    <div class="player-vote-love"
                         v-on:click="voteClicked('1')"
                         :class="{voteSelected: currentTrack.override_type_id == '1', isTPG: isTPG}"></div>
                     <div class="player-vote-leave"
                         v-on:click="voteClicked('2')"
                         :class="{voteSelected: currentTrack.override_type_id == '2', isTPG: isTPG}"></div>
                    <div class="sample-comment"
                         v-on:click="voteCommentClicked()"
                         :class="{voteSelected: (currentTrack.comment || currentTrack.vote_reason_id > 0), isTPG: isTPG}"></div>
                </div>
            </div>
        </div>

        <div id="gvPlayer"></div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: [
    'player-state',
    'is-interactive',
    'allow-voting',
    'playlist-origin',
    'playlist-origin-route',
    'current-track',
    'current-track-position',
    'current-track-duration',
    'playlist-url',
    'short-clip-playback-type-id',
    'is-sample',
    'station-code',
    'is-random',
    'playlist-id',
    'old-track',
    'is-tPG',
  ],
  data() {
    return {
      playButtonText: 'PLAY',
      isGeographicallyAllowed: true,
      errorMessage: '',
      playerIsExpanded: false,
      preMuteVolume: '',
      isMuted: false,
      playerIsHidden: true,
    };
  },
  mounted() {
  },
  methods: {
    /**
            * PLAY/PAUSE button clicked.  emit to mainLayout.vue
            */
    playButtonClicked() {
      this.$emit('togglePlay');
    },
    /**
            *Handle vote click
            * */
    voteClicked(vote) {
      this.$emit('sampleVoteClicked', this.currentTrack, vote);
      this.currentTrack.override_type_id = vote;
    },
    /**
            *Handle comment click
            */
    voteCommentClicked() {
      this.$emit('voteCommentClicked', this.currentTrack);
    },
    /**
            * Handle skip function. Skipping will always play a paused player
            * */
    skipTrack() {
      this.$emit('skipTrack');
    },
    setVolume(volume) {
      $('#si-web-player').prop('volume', volume / 8);
      // jwplayer("gvPlayer").setVolume(volume*14.2);

      const volPer = volume / 8 * 100;
      $('#volumeFront').css('width', `${volPer}%`);
    },
    mutePlayer() {
      const audio = document.getElementById('si-web-player');
      if (audio.volume == 0) {
        $('#si-web-player').prop('volume', this.preMuteVolume);
        $('#volumeFront').css('width', `${this.preMuteVolume}%`);
        this.isMuted = false;
      } else {
        this.preMuteVolume = audio.volume;
        $('#si-web-player').prop('volume', 0);
        $('#volumeFront').css('width', '0%');
        this.isMuted = true;
      }
    },
    togglePlayer() {
      if (this.playerIsExpanded == true) {
        this.playerIsExpanded = false;
      } else {
        this.playerIsExpanded = true;
      }
    },
    redirectToPlaylistOrigin() {
      this.$router.push(this.playlistOriginRoute);
    },

  },
  computed: {
    artistTitleString() {
      let separator = ' - ';
      if (this.playerIsExpanded) {
        separator = '<br>';
      }

      if (this.currentTrack) {
        return this.currentTrack.title + separator + this.currentTrack.artist;
      }
      return `-${separator}-`;
    },
  },
  watch: {
    currentTrackPosition() {
      //    if (this.shortClipPlaybackTypeId == '1' || this.shortClipPlaybackTypeId == '2') {
      //         if (this.currentTrackPosition >= 40) {
      //             this.$emit('skipTrack');
      //         }
      //    }
      let progressWidth = 0;
      progressWidth = this.currentTrackPosition / this.currentTrackDuration * 100;
      $('#trackProgress').css('width', `${progressWidth}%`);

      const progress = Math.round(this.currentTrackPosition);
      let minutes = Math.floor(progress / 60);
      let seconds = progress - minutes * 60;
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      $('#progressText').html(`${minutes}:${seconds}`);
    },
    isGeographicallyAllowed() {
      // hide content and remove playlist.
      // jwplayer('gvPlayer').stop();
    },
    playerState() {
      if (this.playerState == 'playing') {
        this.playerIsHidden = false;
        this.$emit('playerHasBeenOpened');
        this.playButtonText = 'PAUSE';
      } else if (this.playerState == 'paused') {
        this.playButtonText = 'PLAY';
      } else if (this.playerState == 'error') {
        this.playButtonText = 'ERROR';
      } else if (this.playerState == 'buffering') {
        this.playButtonText = 'LOADING';
      } else {
        this.playButtonText = 'PLAY';
      }
    },
  },
};

</script>

<style scoped>
.outer-player-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    height: 0px;
    font-size: 12px;
    padding: 0 4%;
    color: #000;
    background-color: #fff;
    opacity: .9;
    z-index: 99;
    visibility: visible;
}
.outer-player-container.playerIsNotHidden {
    height:50px;
}
.outer-player-container.isTPG {
    height:0;
}
.outer-player-container.isTPG.playerIsNotHidden {
    height:50px;
}
.outer-player-container.isTPG {
    opacity:1;
    border-top:1px solid #ccc;
    background:rgb(255,255,255);
}
.player-container {
    width:1000px;
    margin:0 auto;
}

.trackImageContainer {
    width:40px;
    height:40px;
    float:left;
    margin-right:10px;
}
.trackImageContainer img {
    margin-top:5px;
    height:40px;
    width:40px;
}
.player-container {
}
.trackDetailContainer {
    margin-left:0px;
    width:350px;
    float:left;
}
.trackDetail {
    width:100%;
    margin-top:5px;
}
.playlistDescription,.trackArtist {
    height:18px;
    line-height: 18px;
    width:300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.playlistDescription {
    top:0;
    padding-top:3px;
    margin-bottom: 2px;
    color:#666;
    cursor: pointer;
}
.voteIconContainer {
    width:150px;
    float:left;
    height:60px;
    padding-top: 5px;
}
.player-vote-love, .player-vote-leave,.sample-comment {
    margin-top:1px;
    cursor: pointer;
    width:36px;
    height:36px;
    float:left;
    margin-right:5px;
    padding:0px;
    background-repeat: no-repeat;
}
.player-vote-love {
    background: url("../../assets/images/loveIconPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-leave {
    background: url("../../assets/images/leaveIconPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-love.isTPG.voteSelected {
    background: url("../../assets/images/loveIconGrayPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-leave.isTPG.voteSelected {
    background: url("../../assets/images/leaveIconGrayPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-love.voteSelected {
    background: url("../../assets/images/loveIconYellowPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-leave.voteSelected {
    background: url("../../assets/images/leaveIconYellowPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-love:hover {
    background: url("../../assets/images/loveIconYellowPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-leave:hover {
    background: url("../../assets/images/leaveIconYellowPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-leave.isTPG:hover {
    background: url("../../assets/images/leaveIconGrayPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.player-vote-love.isTPG:hover {
    background: url("../../assets/images/loveIconGrayPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}

.sample-comment {
    background: url("../../assets/images/commentIconPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.sample-comment.has-comment {
    background: url("../../assets/images/commentIconPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.sample-comment:hover {
    background: url("../../assets/images/commentIconYellowPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.sample-comment.voteSelected {
    background: url("../../assets/images/commentIconYellowPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.sample-comment.isTPG.has-comment {
    background: url("../../assets/images/commentIconGrayPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.sample-comment.isTPG.voteSelected {
    background: url("../../assets/images/commentIconGrayPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.sample-comment.isTPG:hover {
    background: url("../../assets/images/commentIconGrayPlayer.svg");
    background-repeat: no-repeat;
    background-size:90%;
}
.controlsContainer {
    width:120px;
    float:left;
    height:50px;
    line-height: 50px;
}
.skipIcon {
    width:20px;
    float:left;
    font-size:1.5em;
    color:#4d4d4d;
    cursor: pointer;
}
.skipIt.isTPG  {
    margin-top:15px;
}
.skip-icon span {
    width:30px;
    height: 30px;
}
.playButtonContainer {
    width:80px;
    float:left;
    padding-top:14px;
}
#playButton {
    width:60px;
    background:yellow;
    cursor:pointer;
    font-family:  Helvetica Neue,Helvetica,Arial,sans-serif;
    padding-top:1px;
    text-align: center;
    height:22px;
    line-height: 22px;
}
#playButton.isTPG {
    background:black;
    color:white;
}
.progressContainer {
    width:260px;
    float:left;
    margin-top:15px;
}
#progressContainer {
    position:relative;
    width:220px;
    height:6px;
    margin-top:7px;
    float:left;
}
.progressBarBottom {
    height:100%;
    background-color:#ccc;
    width:100%;
    position: absolute;
    top: 0;
    left: 0;
}
#trackProgress {
    height:100%;
    background-color:#000;
    width:0%;
    position: absolute;
    top: 0;
    left: 0;
    z-index:10;
}
#progressText {
    text-align:center;
    width:35px;
    float:left;
    padding-left:2px;
    font-size:8px;
    margin-top:4px;
}
.volumeContainer {
    width:100px;
    float:left;
    margin-top: 15px;
}
#volumeContainer {
    position:relative;
    width:55px;
    height:10px;
    margin-top:5px;
    margin-left: 5px;
    float:left;
}
#volumeBack {
    background: url('../../assets/images/volumeBack.png') no-repeat 0 0;
    position:absolute;
    top:0;
    left:0;
    margin-left:5px;
    z-index:10;
    width:100%;
    height:100%;
}
#volumeFront {
    background: url('../../assets/images/volumeFront.png') no-repeat 0 0;
    position:absolute;
    top:0;
    left:0;
    margin-left:5px;
    z-index:11;
    width:50%;
    height:100%;
}
.volumeControlTable {
    border-collapse: collapse;
    height:10px;
    margin-top:1px;
    width:55px;
    cursor:pointer;
    position:absolute;
    z-index:12;
}
.volumeControl {
    width:5px;
    border-left:3px solid white;
    border-bottom:1px solid white;
}
.vCell {
    width:7px;
    z-index:13;
}
.togglePlayer {
    display:none;
}
.volumeIcon {
    float:left;
    margin-top:0px;
    margin-left: 5px;
    cursor: pointer;
}
.volumeIcon.isMuted {
    color:#ccc;
}
@media (max-width:850px) {
    .player-vote-love, .player-vote-leave,.sample-comment {
        height:40px;
        width:40px;
    }
    .togglePlayer {
        display:block;
        position:absolute;
        left:1.5vw;
        cursor:pointer;
        font-size: 14px;
        top:10px;
        transition:.3s;
    }
    .togglePlayer.playerIsExpanded {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
        left:2vw;
        top:15px;
    }
    .outer-player-container.playerIsNotHidden {
        height:50px;
    }
    .outer-player-container {
        height:0px;
        padding: 0%;
        margin:0px;
        transition:.3s;
        opacity: .95;
    }
    .outer-player-container.playerIsExpanded {
        padding:0;
        height:100%;
        opacity: 1;
    }
    .outer-player-container.isTPG.playerIsExpanded {
        padding:0;
        height:100%;
        opacity: 1;
    }
    .player-container {
        margin-top:-18px;
        width:100%;
        height:40px;
    }
    .player-container.playerIsExpanded {
        margin:0;
        height:100vw;
    }
    #volumeContainer {
        display:none;
        width:0px;
    }
    .volumeIcon {
        display: none;
    }
    .controlsContainer {
        padding:0;
        float:right;
        width:40px;
        height:40px;
        margin-top:24px;
        padding-top:5px;
    }
    .controlsContainer.playerIsExpanded {
       float:none;
       position: absolute;
        width:80%;
        top:65vh;
        left:14%;

    }
    .skipIcon {
        display:none;
    }
    .skipIcon.playerIsExpanded {
        position: absolute;
        float:none;
        display:inline-block;
        top:-9px;
        left:32px;
        margin-top:-2px;
    }
    .playButtonContainer {
        float:left;
        width:2em;
        padding:0;
        margin-left:-7px;
    }
    .playButtonContainer.playerIsExpanded {
        float:left;

    }
    #playButton {
        width:40px;
        background:yellow;
        cursor:pointer;
        font-family: "Helvetica Neue";
        padding-top:0px;
        text-align: center;
        height:22px;
        line-height: 22px;
        margin-top:-3px;
    }
    #playButton.playerIsExpanded {
        margin-left:-10px;
    }
    #progressText {
        display:none;
    }
    #progressText.playerIsExpanded {
        display:inline-block;
        float:none;
        top:65vh;
        position:absolute;
        top:-3px;
        right:12vw;
        font-size:10px;
    }
    .progressContainer {
        width:100%;
        float:none;
        position: absolute;
        top:-22px;
        right:0;
    }
    .progressContainer.playerIsExpanded {
        left:52vw;
        top:67vh;
        width:48vw;
    }
    #progressContainer {
        width:100%;
        float:none;
        position: absolute;
        top:0;
        left:0;
        height:3px;
    }
    #progressContainer.playerIsExpanded {
        left:-50%;
        height:6px;
    }
    .progressBarBottom {
        height:100%;
        background-color:#ccc;
        width:100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    #trackProgress {
        height:100%;
        background-color:#000;
        width:0%;
        position: absolute;
        top: 0;
        left: 0;
        z-index:10;
    }
    .trackDetailContainer {
        width:80vw;
        float:none;
        margin: 0 auto;
        clear:left;
        top:0;
    }
    .trackDetailContainer.playerIsExpanded {
        padding:0;
        height: 100vh;
    }
    .trackDetail {
        width: 80vw;
        padding-top:2px;
        height:50px;
    }
    .trackDetail.playerIsExpanded {
        width:80%;
        margin:0px;
        text-align: center;
    }
    .trackArtist {
        height:16px;
        line-height: 16px;
        width:80%;
        position:absolute;
        top:20px;
        margin:0 auto;
        text-align: center;
    }
    .trackArtist.playerIsExpanded {
        position:absolute;
        width:83%;
        bottom:40vh;
        font-size: 14px;
    }
    .playlistDescription {
        width: 80%;
        padding-top:0px;
        margin:0 auto;
        margin-bottom: 2px;
        text-align: center;
        position: absolute;
        top:3px;
        padding-left:3px;
        padding-right: 3px;
    }
    .playlistDescription.playerIsExpanded {
        margin-top:13px;
        top:3px;
        width: 80vw;
        cursor: default;
        font-size: 14px;
    }
    .trackImageContainer {
        display:none;
    }
    .trackImageContainer.playerIsExpanded {
        display: block;
        width: 80vw;
        height: 80vw;
        position:absolute;
        top:8vh;
        left:50%;
    }
    .trackImageContainer.playerIsExpanded:before{
      content:'';
      padding:50% 0;/* vertical value as  100% equals width */
      display:inline-block;
      vertical-align:middle; /* or whatever */
    }
    .trackImageContainer.playerIsExpanded img {
        position: relative;
        left:-50%;
        width:100%;
        height:100%;
    }
    .trackArtist.playerIsExpanded {
        margin-top:58vh;
        height:35px;
    }
    .voteIconContainer {
        bottom:-100px;
        transition:.3s;
    }
    .voteIconContainer.playerIsExpanded {
        display:flex;
        bottom:0;
        width:48vw;
        float:none;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        opacity: 1;
        justify-content: space-between;
    }

 .voteIconContainer.playerIsExpanded > div {
/*     width: 45px;
     display: inline-block;
     vertical-align: top;
     border:1px solid green;
     text-align:center;
     margin:2%;
     padding:20px;*/

    }
}
</style>
